import { PromoMechanic } from "./promo_mechanic"
import { PromoCombo } from "./promo_combo"
import { PromoBenefit } from "./promo_benefit"
import {TipoBeneficio, MecanicaPromocion, TipoProductoParticipante} from "./enums"

export class Promotion {
   /**
    * 
    * @param {*} id 
    * @param {*} name 
    * @param {*} extent_type 
    * @param {*} available 
    * @param {*} quantity 
    * @param {*} url_imagen
    * @param {*} start_date 
    * @param {*} end_date 
    * @param {PromoMechanic} mechanic 
    * @param {PromoBenefit} benefit 
    * @param {PromoCombo[]} combos 
    */
   constructor (id, name, extent_type, available, quantity, url_imagen, start_date, end_date, mechanic, benefit, combos){
      this.id = id
      this.name = name
      this.extent_type = extent_type
      this.available = available
      this.quantity = quantity
      this.url_imagen = url_imagen

      this.start_date = start_date
      this.end_date = end_date
      this.mechanic = mechanic,
      this.benefit = benefit,
      this.combos = combos

      // extras
      this.applicable = false
      this.applicable_quantity = 0
   }

   log() {
      return `
      ID:   ${this.id}\n
      MP:   ${this.mecanicaPromocion()}\n
      TPP:  ${this.tipoProductoParticipante()}\n
      TB:   ${this.tipoBeneficio()}\n
      TPB:  ${this.tipoProductoBeneficio()}\n
      MC:   ${this.multiCombo()}
      `;
   }

   requirementsLog() {
      return `
      ID:   ${this.id}\n
      CONFIG:   ${this.requiereConfiguracion()}\n
      PRODS_CONFIG:   ${this.requiereConfiguracionProductos()}\n
      OFRECE_REGALOS:  ${this.ofreceRegalos()}\n
      REGALOS_CONFIG:  ${this.requiereConfiguracionRegalos()}\n
      OFRECE_DESCUENTO:  ${this.ofreceDescuento()}\n
      `;
   }

   debug(){
      return;
      console.log(this.log());
      console.log("-----")
   }

   mecanicaPromocion(){
      return this.mechanic.type;
   }

   tipoProductoParticipante(){
      return this.mechanic.product_type;
   }

   tipoBeneficio(){
      return this.benefit.benefit_type;
   }

   tipoProductoBeneficio(){
      return this.benefit.product_type;
   }

   multiCombo(){
      return this.combos && this.combos.length > 1;
   }

   // metodos de apoyo
   requiereConfiguracionProductos() {
      return (this.tipoProductoParticipante() === TipoProductoParticipante.Linea 
      || this.tipoProductoParticipante() === TipoProductoParticipante.LineaPresentacion
      || this.tipoProductoParticipante() === TipoProductoParticipante.TODOS)
   }

   ofreceRegalos() {
      return (this.tipoBeneficio() === TipoBeneficio.Souvenir)
   }

   ofreceDescuento() {
      return (this.tipoBeneficio() === TipoBeneficio.Descuento)
   }

   requiereConfiguracionRegalos() {
      return (this.ofreceRegalos() &&
      (this.tipoProductoBeneficio() === TipoProductoParticipante.Linea 
      || this.tipoProductoBeneficio() === TipoProductoParticipante.LineaPresentacion))
   }

   requiereConfiguracion() {
      return this.requiereConfiguracionProductos() || this.requiereConfiguracionRegalos() 
   }

   static fromServicePromotion (promotion) {
      
      const mec = PromoMechanic.fromServiceMechanic(promotion.Mecanica);
      const benefit = PromoBenefit.fromServiceBenefit(promotion.Beneficio);

      let combos = [];
      promotion.Combos.forEach(element => {
         combos.push(PromoCombo.fromServiceCombo(element));
      });
      return new Promotion(
         promotion.ID,
         promotion.Nombre_Promocion,
         promotion.Tipo_Alcance,
         promotion.Disponibles,
         promotion.Cantidad,
         promotion.Url_Imagen,
         promotion.Fecha_Inicio,
         promotion.Fecha_Fin,
         mec,
         benefit,
         combos
      );
   }

}